import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocumentType } from 'src/app/models/document';

export interface SelectTemplateDialogData {
  documentType: DocumentType;
}

@Component({
  selector: 'app-select-template-dialog',
  template: `
    <h2 mat-dialog-title>{{ title }}</h2>
    <div mat-dialog-content>
      <p>{{ description }}</p>
    </div>
    <div mat-dialog-actions align="end" style="gap: 8px;">
      <button mat-raised-button color="primary" (click)="select('old')">
        {{ labelOld }}
      </button>
      <button mat-raised-button (click)="select('new')" style="background-color: #f7ea48; color: #101536;">
        {{ labelNew }}
      </button>
      <button mat-button (click)="close()">
        {{ labelCancel }}
      </button>
    </div>
  `,
  styles: [`
    mat-dialog-actions {
      gap: 8px;
    }
  `]
})
export class SelectTemplateDialogComponent implements OnInit {
  title: string = '';
  description: string = '';
  labelOld: string = '';
  labelNew: string = '';
  labelCancel: string = '';

  constructor(
    public dialogRef: MatDialogRef<SelectTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectTemplateDialogData,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.title = this.translate.instant('LABEL.scegli_template');
    this.description = this.translate.instant('LABEL.scegli_template_description');
    this.labelOld = this.translate.instant('LABEL.vecchio_documento');
    this.labelNew = this.translate.instant('LABEL.nuovo_documento');
    this.labelCancel = this.translate.instant('LABEL.CANCEL');
  }

  select(choice: 'old' | 'new'): void {
    this.dialogRef.close(choice);
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
